import React from 'react';

import { Form, Input } from 'antd';
import { Button, ButtonType, Column, Row } from 'farmhub-ui-core';

import { theme } from 'styled';

import { PartnerDescriptionNoteEditorWrapper } from './styles';

const { TextArea } = Input;

type PartnerNoteDescriptionEditorProps = {
  description: string;
  onSubmit: (val: any) => Promise<void>;
  onCancel: () => void;
};

const PartnerNoteDescriptionEditor = ({
  description,
  onSubmit,
  onCancel,
}: PartnerNoteDescriptionEditorProps): JSX.Element => {
  const [isLoading, setIsLoading] = React.useState(false);
  const [form] = Form.useForm();

  const handleCancel = () => {
    onCancel();
    handleClearData();
  };

  const handleClearData = () => {
    form.setFieldsValue({ description: '' });
  };

  const handleSubmit = () => {
    form.validateFields().then(async (values: any) => {
      setIsLoading(true);
      await onSubmit({
        description: values.description,
      });
      handleClearData();
      setIsLoading(false);
    });
  };

  React.useEffect(() => {
    if (description.length > 0) {
      form.setFieldsValue({ description });
    }
  }, [description]);

  return (
    <PartnerDescriptionNoteEditorWrapper>
      <Form form={form} style={{ width: '100%' }}>
        <Column styles={{ gap: 8 }}>
          <Form.Item
            name="description"
            rules={[
              {
                required: true,
                message: 'Vui lòng nhập mô tả!',
              },
            ]}
            style={{ width: '100%' }}
          >
            <TextArea autoFocus placeholder="Nhập mô tả ghi chú" rows={2} />
          </Form.Item>
          <Row styles={{ gap: 6 }}>
            <Button
              height={theme.button.height.xs}
              loading={isLoading}
              weight="50px"
              onClick={handleSubmit}
            >
              Lưu
            </Button>
            <Button
              height={theme.button.height.xs}
              type={ButtonType.Ghost}
              weight="50px"
              onClick={handleCancel}
            >
              Hủy
            </Button>
          </Row>
        </Column>
      </Form>
    </PartnerDescriptionNoteEditorWrapper>
  );
};

export default PartnerNoteDescriptionEditor;
